import { useState, useRef, useEffect } from "react"
import { Formik, Field, Form } from "formik"
import moment from "moment"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    Wrapper,
    ActionSection,
    ScrollableContent,
    RupeeIcon,
    SideCancelBtn,
    ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import { FaUserPlus, FaRegCalendar } from "react-icons/fa"
import DropZone from "../Notice/Dropzone"
import DateRepetitionModal from "./DateRepetitionModal"
import CategoryCard from "../CategoryCard"
import SelectCategoryModal from "./SelectCategoryModal"
import PaidUserModal from "./PaidUserModal"
import PaidToUserModal from "./PaidToUserModal"
import MultiPropSelectModal from "../MultiPropSelectModal"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import MultiSelectFlat from "../MultiSelectFlat"
import Config from "../../Config"
import AssetMultiSelectModal from "../AssetMultiSelectModal"
import SelectItemModal from "../SelectItemModal"
import { natureExpensesModes } from "../../helpers"

const AddUnpaidExpenses = ({
    handleClose,
    expenseData,
    vendorList,
    categories,
    setIsAddVendor,
    property,
    addUnpaidExpenseLoading,
    addUnpaidExpenseMutate
}) => {
    const formikRef = useRef(null)
    const [height, setHeight] = useState(window.innerHeight)
    const [showDateRepetitionModal, setShowDateRepetitionModal] = useState(false)
    const [showCategoryModal, setShowCategoryModal] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedPaidBy, setSelectedPaidBy] = useState('')
    const [selectedPaidTo, setSelectedPaidTo] = useState('')
    const [showPaidModal, setShowPaidModal] = useState(false)
    const [showPaidToModal, setShowPaidToModal] = useState(false)
    const [showPropertyModal, setShowPropertyModal] = useState(false)
    const [dueDateOpen, setDueDateOpen] = useState(false)
    const [showFlatModal, setShowFlatModal] = useState(false)
    const [showAssetModal, setShowAssetModal] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])
    const filteredProperties = property?.filter(prop => prop.id !== 0) || [];

    const initialValues = {
        amount: "",
        category: "",
        expenseTitle: "",
        dueDate: new Date(),
        properties: [],
        flats: [],
        assets: [],
        paidBy: "",
        paidTo: "",
        description: "",
        file: null,
        natureOfExpenses: 1,
    }
    const shouldShowFlatSelector = () => {
        const selectedProperties = formikRef.current?.values.properties || [];

        if (selectedProperties.length !== 1) return false;

        const selectedProperty = filteredProperties.find(
            prop => prop.id === selectedProperties[0]
        );

        return selectedProperty?.type === Config.PROPERTY_TYPE.FLAT && selectedProperty?.flats?.length > 0;
    };


    const getFlatsForSelectedProperty = () => {
        const selectedProperties = formikRef.current?.values.properties || [];
        if (selectedProperties.length !== 1) return [];

        const selectedProperty = filteredProperties.find(
            prop => prop.id === selectedProperties[0]
        );

        return selectedProperty?.flats || [];
    };
    const handleSubmit = (values) => {
        const amountRegex = /^(?!0+$)\d{1,8}$/
        const maxAmount = 10000000;
        if (!amountRegex.test(values.amount) || parseInt(values.amount) > maxAmount) {
            toast.error("Amount must be between 1 and 1,00,00,000 and contain only numbers")
            return
        }
        if (!values.category) {
            toast.error("Category is required")
            return
        }

        if (!values.paidBy) {
            toast.error("Paid by is required")
            return
        }
        if (!values.paidTo) {
            toast.error("Paid to is required")
            return
        }

        if (!values.dueDate) {
            toast.error("Due date is required")
            return
        }
        if (!values.natureOfExpenses) {
            toast.error("Nature of expenses is required")
            return
        }
        const formData = new FormData()
        formData.append("amount", Number(values.amount));
        formData.append("type", Number(values.category));
        formData.append("expenseTitle", values?.expenseTitle?.trim() || '');
        formData.append("description", values.description);
        formData.append("dueDate", moment(values.dueDate).format("YYYY-MM-DD"));
        formData.append("paidBy", Number(values.paidBy));
        formData.append("paidTo", Number(values.paidTo));
        if (!values.properties.includes(0)) {
            formData.append("propertyIds", values.properties.join(","));
        }
        if (values.flats && values.flats.length > 0) {
            formData.append("flatIds", values.flats.join(","));
        }
        if (values.assets && values.assets.length > 0) {
            formData.append("assetIds", values.assets.join(","));
        }
        formData.append("paidByUserType", Number(selectedPaidBy?.userType))
        formData.append("paidToUserType", Number(selectedPaidTo?.userType))
        if (values.file) {
            formData.append("file", values.file[0])
        }
        formData.append("expenseNature", values.natureOfExpenses)
        addUnpaidExpenseMutate(formData)
    }

    const handleSelectedProperties = (selectedProperties) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("properties", selectedProperties)
            formikRef.current.setFieldValue("flats", [])
        }
    }

    const handlePropertySave = (properties) => {
        handleSelectedProperties(properties)
        setShowPropertyModal(false)
    }
    const handleSelectedFlats = (selectedFlatsList) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("flats", selectedFlatsList)
        }
    }

    const handleFlatSave = (flats) => {
        handleSelectedFlats(flats)
        setShowFlatModal(false)
    }
    const handleSelectedPaidBy = (selectedOption) => {
        setSelectedPaidBy(selectedOption)

        if (formikRef.current) {
            formikRef.current.setFieldValue("paidBy", selectedOption.id)
        }
    }

    const handlePaidSave = (paid) => {
        handleSelectedPaidBy(paid)
        setShowPaidModal(false)
    }
    const handleSelectedPaidTo = (selectedOption) => {
        setSelectedPaidTo(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidTo", selectedOption.id)
        }
    }

    const handlePaidToSave = (paid) => {
        handleSelectedPaidTo(paid)
        setShowPaidToModal(false)
    }
    const handleSelectedCategory = (selectedOption) => {
        setSelectedCategory(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("category", selectedOption.value)
        }
    }

    const handleCategorySave = (category) => {
        handleSelectedCategory(category)
        setShowCategoryModal(false)
    }
    // const handleSelectedAssets = (selectedAssetIds) => {
    //     if (formikRef.current) {
    //         formikRef.current.setFieldValue("assets", selectedAssetIds);
    //     }
    // };

    // const handleAssetSave = (assets) => {
    //     handleSelectedAssets(assets);
    //     setShowAssetModal(false);
    // };
    const handleSelectedAsset = (asset) => {
        setSelectedAsset(asset);
        if (formikRef.current) {
            // Store as array since we want to support multiple selection
            const selectedAssets = asset ? [asset.id] : [];
            formikRef.current.setFieldValue("assets", selectedAssets);
        }
    };

    const handleAssetSave = (asset) => {
        handleSelectedAsset(asset);
        setShowAssetModal(false);
    };

    const renderSelectedAssets = (selected = []) => {
        if (!selected.length) return "Select Assets";
        const assetsList = expenseData?.assets || [];
        const selectedAssetsList = assetsList?.filter((asset) => selected.includes(asset.id));
        if (!selectedAssetsList?.length) return "Select Assets";
        const maxToShow = 2;
        const namesToShow = selectedAssetsList.slice(0, maxToShow).map((asset) => asset.name);
        const remainingCount = selectedAssetsList.length - maxToShow;
        return (
            <div className="flex items-center gap-1 truncate">
                {namesToShow.join(", ")}
                {remainingCount > 0 && <span className="ml-1 text-gray-500">+{remainingCount}</span>}
            </div>
        );
    };

    const handleDateRepetitionSave = (date, repetition, noOfMonths, dueDate) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentDate", date)
            formikRef.current.setFieldValue("repetition", repetition)
            formikRef.current.setFieldValue("noOfMonths", noOfMonths)
            formikRef.current.setFieldValue("dueDate", dueDate)
        }
    }

    const renderSelectedProperties = (selected = []) => {
        if (!selected.length) return "Select Properties"
        const selectedProperties = filteredProperties?.filter((prop) => selected.includes(prop.id))
        if (!selectedProperties?.length) return "Select Properties"
        const maxToShow = 2
        const namesToShow = selectedProperties.slice(0, maxToShow).map((prop) => prop.name)
        const remainingCount = selectedProperties.length - maxToShow
        return (
            <div className="flex items-center gap-1 truncate">
                {namesToShow.join(", ")}
                {remainingCount > 0 && <span className="ml-1 text-gray-500">+{remainingCount}</span>}
            </div>
        )
    }

    const renderSelectedFlats = (selected = []) => {
        if (!selected.length) return "Select Flats"
        const flatsList = getFlatsForSelectedProperty()
        const selectedFlatsList = flatsList?.filter((flat) => selected.includes(flat.id))
        if (!selectedFlatsList?.length) return "Select Flats"
        const maxToShow = 2
        const namesToShow = selectedFlatsList.slice(0, maxToShow).map((flat) => `Flat ${flat.name}`)
        const remainingCount = selectedFlatsList.length - maxToShow
        return (
            <div className="flex items-center gap-1 truncate">
                {namesToShow.join(", ")}
                {remainingCount > 0 && <span className="ml-1 text-gray-500">+{remainingCount}</span>}
            </div>
        )
    }
    const isCategory55or56 = () => {
        const categoryId = formikRef.current?.values?.category;
        return [55, 56].includes(Number(categoryId));
    };

    const shouldShowAsset = () => {
        const categoryId = formikRef.current?.values?.category;
        return [23, 76].includes(Number(categoryId));
    };
    return (
        <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
            <ModalHeader>
                <h1 className="text-lg font-medium text-white">Add Unpaid Expense</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <div className="custom-scrollbar flex h-full flex-col justify-between px-6">

                <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>

                                    <InputGroup>
                                        <Label htmlFor="category">Category *</Label>
                                        <CategoryCard type="button" selectedCategory={selectedCategory} title="Category" onClick={() => setShowCategoryModal(true)} />
                                    </InputGroup>

                                    {selectedCategory?.label === 'Others' && (
                                        <InputGroup>
                                            <Label htmlFor="expenseTitle">Expense Title *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    id="expenseTitle"
                                                    name="expenseTitle"
                                                    autoComplete="off"
                                                    placeholder="Enter expense title"
                                                    className="w-full"
                                                    maxLength={30}
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    )}

                                    <InputGroup>
                                        <Label htmlFor="amount">Amount *</Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="text"
                                                name="amount"
                                                id="amount"
                                                autoComplete="off"
                                                className="w-full truncate pl-6"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="paidBy">Paid by *</Label>
                                        <CategoryCard type="button" selectedCategory={selectedPaidBy} title="Paid By" onClick={() => setShowPaidModal(true)} />
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="paidTo">Paid to *</Label>
                                        <CategoryCard type="button" selectedCategory={selectedPaidTo} title="Paid To" onClick={() => setShowPaidToModal(true)} />
                                    </InputGroup>

                                    <div className="-mt-2 flex items-end justify-end">
                                        <Vendor
                                            type="button"
                                            onClick={() => {
                                                setIsAddVendor(true)
                                            }}
                                        >
                                            <FaUserPlus className="mr-1 mt-0.5" />
                                            Add Vendor
                                        </Vendor>
                                    </div>

                                    {/* <InputGroup>
                                        <Label>Select property/properties (optional)</Label>
                                        <CategoryCard
                                            type="button"
                                            selectedCategory={values.properties.length > 0 ? {
                                                label: renderSelectedProperties(values.properties),
                                                value: "properties"
                                            } : null}
                                            title="Property/or Properties"
                                            onClick={() => {
                                                if (isCategory55or56() && values.assets.length > 0) {
                                                    toast.info("You have already selected an asset. Clear it first to select property.");
                                                    return;
                                                }
                                                setShowPropertyModal(true);
                                            }}
                                            className={isCategory55or56() && values.assets.length > 0 ? "opacity-50 cursor-not-allowed" : ""}
                                        />

                                        {isCategory55or56() && values.assets.length > 0 && values.properties.length === 0 && (
                                            <p className="text-xs text-blue-500 mt-1">Asset selected. Property is disabled.</p>
                                        )}
                                    </InputGroup> */}
                                    <InputGroup>
                                        <Label>Select property/properties (optional)</Label>
                                        <CategoryCard
                                            type="button"
                                            selectedCategory={values.properties.length > 0 ? {
                                                label: renderSelectedProperties(values.properties),
                                                value: "properties"
                                            } : null}
                                            title="Property/or Properties"
                                            onClick={() => setShowPropertyModal(true)}
                                        />
                                    </InputGroup>
                                    {shouldShowFlatSelector() && (
                                        <InputGroup>
                                            <Label>Select Flat/Flats (optional)</Label>
                                            <CategoryCard
                                                type="button"
                                                selectedCategory={values.flats && values.flats.length > 0 ? {
                                                    label: renderSelectedFlats(values.flats),
                                                    value: "flats"
                                                } : null}
                                                title="Flat/or Flats"
                                                onClick={() => setShowFlatModal(true)}
                                            />
                                        </InputGroup>
                                    )}
                                    {shouldShowAsset() && (
                                        <InputGroup>
                                            <Label>Select asset (optional)</Label>
                                            <CategoryCard
                                                type="button"
                                                selectedCategory={selectedAsset ? {
                                                    label: selectedAsset.name,
                                                    value: selectedAsset.id
                                                } : null}
                                                title="Select Asset"
                                                onClick={() => setShowAssetModal(true)}
                                            />

                                        </InputGroup>)}
                                    {/* {shouldShowAsset() && (
                                        <InputGroup>
                                            <Label>Select asset (optional)</Label>
                                            <CategoryCard
                                                type="button"
                                                selectedCategory={values.assets && values.assets.length > 0 ? {
                                                    label: renderSelectedAssets(values.assets),
                                                    value: "assets"
                                                } : null}
                                                title="Select Asset/Assets"
                                                onClick={() => {

                                                    if (isCategory55or56() && values.properties.length > 0) {
                                                        toast.info("You have already selected a property. Clear it first to select asset.");
                                                        return;
                                                    }
                                                    setShowAssetModal(true);
                                                }}
                                                className={isCategory55or56() && values.properties.length > 0 ? "opacity-50 cursor-not-allowed" : ""}
                                            />

                                            {isCategory55or56() && values.properties.length > 0 && values.assets.length === 0 && (
                                                <p className="text-xs text-blue-500 mt-1">Property selected. Asset is disabled.</p>
                                            )}
                                        </InputGroup>
                                    )} */}
                                    <InputGroup>
                                        <Label htmlFor="dueDate">Due Date *</Label>
                                        <FieldWrappers>
                                            <DatePicker
                                                //selected={values.dueDate ? new Date(values.dueDate) : null}
                                                selected={values.dueDate ? moment(values.dueDate, "YYYY-MM-DD").toDate() : null}
                                                onChange={(date) => {
                                                    setFieldValue("dueDate", moment(date).format("YYYY-MM-DD"));
                                                    setDueDateOpen(false);
                                                }}
                                                onClickOutside={() => setDueDateOpen(false)}
                                                onSelect={() => setDueDateOpen(false)}
                                                open={dueDateOpen}
                                                onInputClick={() => setDueDateOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="items-center cursor-pointer w-full pl-6"
                                                placeholderText="Select due date"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                wrapperClassName="w-full"
                                                name="dueDate"
                                                id="dueDate"
                                                autoComplete="off"
                                                onFocus={(e) => e.target.blur()}
                                                popperPlacement="bottom-start"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>


                                    <InputGroup>
                                        <Label htmlFor="description">Description (optional)</Label>
                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description"
                                        />
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Nature of Expenses *</Label>
                                        <NatureModeWrapper>
                                            {natureExpensesModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setFieldValue("natureOfExpenses", mode.value, false)
                                                    }}
                                                    className={
                                                        values.natureOfExpenses === mode.value ? "bg-blue-200" : "bg-gray-100"
                                                    }
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </NatureModeWrapper>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="file">Document(optional)</Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="file"
                                                type="text"
                                                id="file"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        acceptedFiles="image/*,application/pdf"
                                                        File={props.field.value ? [props.field.value] : null}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>

                            <ActionSection>


                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>

                                <SubmitBtn type="submit" disabled={addUnpaidExpenseLoading}>
                                    {addUnpaidExpenseLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>

                            <DateRepetitionModal
                                isOpen={showDateRepetitionModal}
                                onClose={() => setShowDateRepetitionModal(false)}
                                onSave={handleDateRepetitionSave}
                                initialDate={values.paymentDate}
                                initialRepetition={values.repetition}
                                initialNoOfMonths={values.noOfMonths}
                            />
                            <SelectCategoryModal
                                isOpen={showCategoryModal}
                                onClose={() => setShowCategoryModal(false)}
                                onSelect={handleCategorySave}
                                categories={categories}
                                selectedCategory={selectedCategory}
                            />
                            <PaidUserModal
                                isOpen={showPaidModal}
                                onClose={() => setShowPaidModal(false)}
                                onSelect={handlePaidSave}
                                options={expenseData?.users}
                                selectedPaidBy={selectedPaidBy}
                            />
                            <PaidToUserModal
                                isOpen={showPaidToModal}
                                onClose={() => setShowPaidToModal(false)}
                                onSelect={handlePaidToSave}
                                options={vendorList || expenseData?.vendors}
                                landlordList={expenseData?.landlords}
                                selectedPaidTo={selectedPaidTo}
                                title="Select Paid To"
                            />
                            <MultiPropSelectModal
                                isOpen={showPropertyModal}
                                onClose={() => setShowPropertyModal(false)}
                                onSelect={handlePropertySave}
                                options={filteredProperties}
                                selectedProperties={values.properties}
                            />
                            <MultiSelectFlat
                                isOpen={showFlatModal}
                                onClose={() => setShowFlatModal(false)}
                                onSelect={handleFlatSave}
                                options={getFlatsForSelectedProperty()}
                                selectedFlats={values.flats || []}
                                title="Select Flat/Flats"
                            />
                            <SelectItemModal
                                isOpen={showAssetModal}
                                onClose={() => setShowAssetModal(false)}
                                onSelect={handleAssetSave}
                                options={expenseData?.assets || []}
                                selectedItem={selectedAsset}
                                title="Select Asset"
                                searchPlaceholder="Search assets..."
                                idKey="id"
                                nameKey="name"
                                descriptionKeys={[["vehicleNum"]]}
                                emptyMessage="No assets available"
                                noResultsMessage="No assets found"
                            />
                            {/* <AssetMultiSelectModal
                                isOpen={showAssetModal}
                                onClose={() => setShowAssetModal(false)}
                                onSelect={handleAssetSave}
                                options={expenseData?.assets || []}
                                selectedAssets={values.assets || []}
                                isLoading={false}
                            /> */}
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    )
}


const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const FieldWrapper = tw.div`w-full`
const NatureModeWrapper = tw.div`grid grid-cols-2 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
export default AddUnpaidExpenses